import {
  BackgroundTask,
  PaginatedTasksResponse,
} from '@/services/backgroundTaskService'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  cancelBackgroundTask,
  doReleaseHeldBackgroundTasks,
  getBackgroundTasks,
} from '../thunks/backgroundTaskThunk'

interface BackgroundTaskState {
  items: BackgroundTask[]
  page: number
  pageSize: number
  totalCount: number
  totalPages: number
  loading: boolean
  error: string | null
}

const initialState: BackgroundTaskState = {
  items: [],
  page: 1,
  pageSize: 25,
  totalCount: 0,
  totalPages: 0,
  loading: false,
  error: null,
}

const backgroundTaskSlice = createSlice({
  name: 'backgroundTasks',
  initialState,
  reducers: {
    resetBackgroundTasks: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBackgroundTasks.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        getBackgroundTasks.fulfilled,
        (state, { payload }: PayloadAction<PaginatedTasksResponse>) => {
          state.items = payload.items
          state.page = payload.page
          state.pageSize = payload.pageSize
          state.totalCount = payload.totalCount
          state.totalPages = payload.totalPages
          state.loading = false
        },
      )
      .addCase(getBackgroundTasks.rejected, (state, { error }) => {
        state.loading = false
        state.error = error.message ?? 'Failed to load background tasks'
      })
      .addCase(
        doReleaseHeldBackgroundTasks.fulfilled,
        (state, { payload }: PayloadAction<BackgroundTask>) => {
          state.items = state.items.filter((t) => t.uid !== payload.uid)
          state.totalCount = Math.max(0, state.totalCount - 1)
        },
      )
      .addCase(
        cancelBackgroundTask.fulfilled,
        (state, { payload }: PayloadAction<BackgroundTask>) => {
          const idx = state.items.findIndex((t) => t.uid === payload.uid)
          if (idx !== -1) state.items[idx] = payload
        },
      )
  },
})

export const { resetBackgroundTasks } = backgroundTaskSlice.actions
export default backgroundTaskSlice.reducer
